import { View } from 'backbone.marionette';
import template from './index.jst';
import './index.styl';

class TippingLayout extends View {

	get template() {
		return template;
	}

	get className() {
		return "tipping-tips-layout";
	}

	regions() {
		return {
			user_info: '.user-info',
			content: '.content',
			gamebar: '.gamebar',
			widget_1: '.widget-1',
			widget_2: '.widget-2',
			widget_3: '.widget-3'
		};
	}

}

export default TippingLayout;